import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (
	item?: Order.Model["executingStages"],
	dateFns?: DateFns,
) => {
	const timestamp = item?.accepted?.timestamp;
	const content =
		timestamp && dateFns
			? dateFns.formatTime(timestamp, {
					formatTime: "HH:mm:ss",
					isTimezone: true,
			  })
			: "";
	const backgroundColor = timestamp ? "#4CAF50" : undefined;
	return { content, backgroundColor };
};

export default cellProcessing;
